import { Button, Typography } from '@mui/material'
import './tours.css'
import maskImage from '../../images/travel/background2.png'
import travelImage from '../../images/travel/srilankain.jpg'
import { forwardRef } from 'react'

export const Tours = forwardRef((props, ref) => {

  return <div ref={ref} className="toure-parallax">
  <div className="toure-overlay">
    <div className="toure-content">
      <h1 className="toure-title-title">Time To Travel</h1>
      <h2 className="toure-title-discription">Enjoy In the Wild</h2>
      <p className="toure-discription">
        Travel agents with local connections, knowledge, and expertise can make your holiday more carefree and fun-filled.
        They can organize your trip, get the best deals, and ensure an unforgettable experience.
      </p>
      <a
        href="https://heavenupontravels.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="toure-btn"
      >
        Visit the Website
      </a>
    </div>
  </div>
</div>



  // return (
  //   <div className="toure-section">
  //     <div className='toure'>
  //       <div className="toure-msg-box">
  //         <div className="toure-title">
  //           <p className='toure-title-title'>Time To Travel</p>
  //           <p className='toure-title-discription'>Enjoy In the Wild</p>
  //           <p className='toure-discription'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat asperiores dolorem totam rerum veritatis, eaque voluptatum, pariatur ut tempore doloribus a molestiae temporibus minima consectetur quae! Unde beatae sint laboriosam.</p>
  //           <Button>See More</Button>
  //         </div>
  //       </div>
  //       <div className="travel-img-box">
  //         <img className='toure-img' src={travelImage} alt="" />
  //         <img className='toure-mask' src={maskImage} />
  //       </div>
  //     </div>
  //   </div>
  // ))
})
